// @flow
import {createAction} from 'redux-actions';

export const savePaymentInfoAction = createAction('SAVE_PAYMENT_INFO');

export const savePaymentInfo = (paymentInfo) => {
   return savePaymentInfoAction({
       data: {
           paymentInfo,
       }
   });
};
